import {
  CallDirection,
  CampaignQC,
  CreateQCPayload,
  UpdateQCPayload,
  FilterPayload,
  FilterType,
  FormQCModel,
  QCStatus,
} from '../../../../../common/services/SmartQC.service';
import * as moment from 'moment';

export enum ModalAction {
  ADD = 'add',
  EDIT = 'edit',
  CLOSE = 'close',
}

export enum TableDynamicAction {
  EXECUTE_CAMPAIGN = 'execute_campaign',
  VIEW_REPORT = 'view_report',
  VIEW_CAMPAIGN = 'view_campaign',
  EDIT_CAMPAIGN = 'edit_campaign',
}

export enum FormFieldCode {
  NAME = 'name',
  DESCRIPTION = 'description',
  FILTER_TYPE = 'filter_type',
  MAXIMUM_AUDIO = 'maximum_audio',
  // common filter ticket
  TICKET_FROM = 'ticket_from',
  TICKET_TO = 'ticket_to',
  CALL_DURATION_FROM = 'call_duration_from',
  CALL_DURATION_TO = 'call_duration_to',
  CALL_DIRECTION = 'call_direction',
  // multiple filter ticket
  TICKET_FROM_TIME = 'ticket_from_time',
  TICKET_TO_TIME = 'ticket_to_time',
  ASSIGN_GROUP_ID = 'assign_group_id',
  ASSIGN_AGENT_ID = 'assign_agent_id',
  STATUS = 'status',
  PRIORITY_ID = 'priority_id',
  // one filter ticket
  CODE = 'code',
  CALL_STATUS = 'call_status',
}

export function buildQCModelFilter(campaignQC?: CampaignQC) {
  const modelFilter = {
    [FormFieldCode.TICKET_FROM]: null,
    [FormFieldCode.TICKET_TO]: null,
    [FormFieldCode.CALL_DURATION_FROM]: null,
    [FormFieldCode.CALL_DURATION_TO]: null,
    [FormFieldCode.CALL_DIRECTION]: [],
  };

  if (campaignQC && campaignQC.ticket_filter && campaignQC.ticket_filter.ticket_from) {
    modelFilter[FormFieldCode.TICKET_FROM] = campaignQC.ticket_filter.ticket_from;
  }

  if (campaignQC && campaignQC.ticket_filter && campaignQC.ticket_filter.ticket_to) {
    modelFilter[FormFieldCode.TICKET_TO] = campaignQC.ticket_filter.ticket_to;
  }

  if (campaignQC && campaignQC.call_filter && campaignQC.call_filter.call_duration_from) {
    modelFilter[FormFieldCode.CALL_DURATION_FROM] = campaignQC.call_filter.call_duration_from;
  }

  if (campaignQC && campaignQC.call_filter && campaignQC.call_filter.call_duration_to) {
    modelFilter[FormFieldCode.CALL_DURATION_TO] = campaignQC.call_filter.call_duration_to;
  }

  if (campaignQC && campaignQC.call_filter && campaignQC.call_filter.call_direction) {
    modelFilter[FormFieldCode.CALL_DIRECTION] = [campaignQC.call_filter.call_direction];
  }

  return modelFilter;
}

export function buildQCModelFilterOneTicket(campaignQC?: CampaignQC) {
  const modelFilter = {
    ...buildQCModelFilter(campaignQC),
    [FormFieldCode.CODE]: null,
    [FormFieldCode.CALL_STATUS]: [],
  };

  if (campaignQC && campaignQC.ticket_filter && campaignQC.ticket_filter.code) {
    modelFilter[FormFieldCode.CODE] = campaignQC.ticket_filter.code;
  }

  if (campaignQC && campaignQC.call_filter && campaignQC.call_filter.call_status) {
    modelFilter[FormFieldCode.CALL_STATUS] = campaignQC.call_filter.call_status;
  }

  return modelFilter;
}

export function buildQCModelFilterMultipleTicket(campaignQC?: CampaignQC) {
  const modelFilter = {
    ...buildQCModelFilter(campaignQC),
    [FormFieldCode.TICKET_FROM_TIME]: null,
    [FormFieldCode.TICKET_TO_TIME]: null,
    [FormFieldCode.ASSIGN_AGENT_ID]: [],
    [FormFieldCode.ASSIGN_GROUP_ID]: [],
    [FormFieldCode.STATUS]: [],
    [FormFieldCode.PRIORITY_ID]: [],
  };

  if (campaignQC && campaignQC.ticket_filter && campaignQC.ticket_filter.ticket_from_time) {
    modelFilter[FormFieldCode.TICKET_FROM_TIME] = campaignQC.ticket_filter.ticket_from_time;
  }

  if (campaignQC && campaignQC.ticket_filter && campaignQC.ticket_filter.ticket_to_time) {
    modelFilter[FormFieldCode.TICKET_TO_TIME] = campaignQC.ticket_filter.ticket_to_time;
  }

  if (campaignQC && campaignQC.ticket_filter && Array.isArray(campaignQC.ticket_filter.assign_agent_id)) {
    modelFilter[FormFieldCode.ASSIGN_AGENT_ID] = campaignQC.ticket_filter.assign_agent_id;
  }

  if (campaignQC && campaignQC.ticket_filter && Array.isArray(campaignQC.ticket_filter.assign_group_id)) {
    modelFilter[FormFieldCode.ASSIGN_GROUP_ID] = campaignQC.ticket_filter.assign_group_id;
  }

  if (campaignQC && campaignQC.ticket_filter && Array.isArray(campaignQC.ticket_filter.status)) {
    modelFilter[FormFieldCode.STATUS] = campaignQC.ticket_filter.status.map(status => status.toString());
  }

  if (campaignQC && campaignQC.ticket_filter && Array.isArray(campaignQC.ticket_filter.priority_id)) {
    modelFilter[FormFieldCode.PRIORITY_ID] = campaignQC.ticket_filter.priority_id;
  }

  return modelFilter;
}

export function buildCreateQCModel() {
  return {
    [FormFieldCode.NAME]: '',
    [FormFieldCode.DESCRIPTION]: null,
    [FormFieldCode.FILTER_TYPE]: FilterType.ONE_TICKET,
    [FormFieldCode.MAXIMUM_AUDIO]: 1,
    ...buildQCModelFilterOneTicket(),
  };
}

export function buildEditQCModel(campaignQC: CampaignQC) {
  let model = {
    [FormFieldCode.NAME]: campaignQC.name,
    [FormFieldCode.DESCRIPTION]: campaignQC.description,
    [FormFieldCode.FILTER_TYPE]: campaignQC.filter_type,
    [FormFieldCode.MAXIMUM_AUDIO]: campaignQC.maximum_audio,
  };

  let filterModel: any;
  if (campaignQC.filter_type === FilterType.ONE_TICKET) {
    filterModel = buildQCModelFilterOneTicket(campaignQC);
  }

  if (campaignQC.filter_type === FilterType.MULTIPLE_TICKET) {
    filterModel = buildQCModelFilterMultipleTicket(campaignQC);
  }

  return {
    ...model,
    ...filterModel,
  };
}

export function buildFilterPayloadSubmit(model: FormQCModel): FilterPayload {
  const filterPayload: FilterPayload = {};

  if (model.ticket_from) filterPayload.ticket_from = moment(model.ticket_from).format('YYYY-MM-DD');

  if (model.ticket_to) filterPayload.ticket_to = moment(model.ticket_to).format('YYYY-MM-DD');

  if (Array.isArray(model.call_direction) && model.call_direction.length > 0) {
    filterPayload.call_direction = model.call_direction[0];
  }

  if (model.call_duration_from) filterPayload.call_duration_from = model.call_duration_from;

  if (model.call_duration_to) filterPayload.call_duration_to = model.call_duration_to;

  if (model.filter_type === FilterType.ONE_TICKET) {
    if (model.code) filterPayload.code = model.code;

    if (Array.isArray(model.call_status) && model.call_status.length > 0) filterPayload.call_status = model.call_status;
  } else {
    if (model.ticket_from_time) filterPayload.ticket_from_time = model.ticket_from_time;

    if (model.ticket_to_time) filterPayload.ticket_to_time = model.ticket_to_time;

    filterPayload.assign_agent_id = model.assign_agent_id || [];
    filterPayload.assign_group_id = model.assign_group_id || [];
    filterPayload.status = (model.status || []).map(x => Number(x));
    filterPayload.priority_id = model.priority_id || [];
  }

  return filterPayload;
}

export function buildCreatePayloadSubmit(model: FormQCModel): CreateQCPayload {
  const payload: CreateQCPayload = {
    name: model.name,
    description: model.description,
    filter_type: model.filter_type,
    filter_payload: buildFilterPayloadSubmit(model),
    maximum_audio: Number(model.maximum_audio),
  };

  return payload;
}

export function buildEditPayloadSubmit(model: FormQCModel, currentQC: CampaignQC): UpdateQCPayload {
  const payload: UpdateQCPayload = {};

  if (model.name !== currentQC.name) payload.name = model.name;
  if (model.description !== currentQC.description) payload.description = model.description;
  if (model.filter_type !== currentQC.filter_type) payload.filter_type = model.filter_type;
  if (model.maximum_audio !== currentQC.maximum_audio) payload.maximum_audio = model.maximum_audio;

  payload.filter_payload = buildFilterPayloadSubmit(model);

  return payload;
}

export function getDisplayContentStatusColumn(status: QCStatus) {
  switch (status) {
    case QCStatus.PENDING:
      return '<div class="block-column block-error">Chưa xử lý</div>';
    case QCStatus.RUNNING:
      return '<div class="block-column block-primary">Đang xử lý</div>';
    case QCStatus.DONE:
      return '<div class="block-column block-success">Đã hoàn thành</div>';
    default:
      return 'Không xác định';
  }
}

export function getDisplayContentTimeColumn(qc: CampaignQC) {
  if (qc.status === QCStatus.PENDING) return '00:00:00';
  if (qc.status === QCStatus.DONE) {
    const startTime = moment(qc.start_running);
    const endTime = moment(qc.end_running);
    const duration = moment.duration(endTime.diff(startTime));
    const totalDuration = moment().startOf('day').add(duration);

    return totalDuration.format('HH:mm:ss');
  }

  return '--:--:--';
}

export function buildTableColumns() {
  return [
    {
      title: 'STT',
      key: 'index',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Tên chiến dịch',
      key: 'name',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Số cuộc',
      key: 'total_tickets',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Trạng thái',
      key: 'display_status',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Thời gian',
      key: 'display_time',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
  ];
}

export function buildTableDynamicActions() {
  const actions = [
    {
      action: TableDynamicAction.VIEW_CAMPAIGN,
      title: 'Xem chiến dịch',
      display: true,
      content: '<i class="fa fa-info"  style="cursor: pointer;"></i>',
      display_key: 'display_btn_view_campaign',
    },
    {
      action: TableDynamicAction.EDIT_CAMPAIGN,
      title: 'Sửa chiến dịch',
      display: true,
      content: `<i class="fa fa-pencil-square-o" style="cursor: pointer;"></i>`,
      display_key: 'display_btn_edit_campaign',
    },
    {
      action: TableDynamicAction.EXECUTE_CAMPAIGN,
      title: 'Chạy chiến dịch',
      display: true,
      content: `<i class="fa fa-play"  style="cursor: pointer;"></i>`,
      display_key: 'display_btn_execute_campaign',
    },
    {
      action: TableDynamicAction.VIEW_REPORT,
      title: 'Xem báo cáo',
      display: true,
      icon_class: `<i class="fa fa-bar-chart"  style="cursor: pointer;"></i>`,
      display_key: 'display_btn_view_report',
    },
  ];

  return actions;
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/smart-qc/campaign/campaign.util.ts